import type { UpdaterRunSummary } from '@teachpartner/contracts';
import { formatTime } from '../../components/time';
import { kindLabel, RunStatusPill, triggerLabel } from './run-status';

/** Every run the updater kept (newest first); choosing one shows its details. */
export function RunHistory({
  runs,
  selectedId,
  onSelect,
}: {
  runs: readonly UpdaterRunSummary[];
  selectedId: string | null;
  onSelect(id: string): void;
}) {
  return (
    <section aria-label="History">
      <h2>History</h2>
      {runs.length === 0 ? (
        <p>No runs yet.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Started</th>
              <th>Kind</th>
              <th>Version</th>
              <th>Trigger</th>
              <th>Actor</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {runs.map((r) => (
              <tr
                key={r.id}
                className={r.id === selectedId ? 'selected' : undefined}
                aria-current={r.id === selectedId ? 'true' : undefined}
              >
                <td>
                  <button type="button" className="link" onClick={() => onSelect(r.id)}>
                    {formatTime(r.startedAt)}
                  </button>
                </td>
                <td>{kindLabel(r.kind)}</td>
                <td>{r.version ?? '—'}</td>
                <td>{triggerLabel(r.trigger)}</td>
                <td>{r.actor}</td>
                <td>
                  <RunStatusPill status={r.status} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
